import { Service, signal } from '@angular/core';

import { Transfer } from '../models/medic-actiuni.model';
import { DocCertProfCurent } from '../models/medic-doc.model';
import { Notificari } from '../models/nav-notificari.model';

/** Alertele CMJ: transferuri si certificate in asteptare, plus notificarile din antet. */
@Service()
export class AlertStore {
    private readonly transferState = signal<Transfer[]>([]);
    private readonly cpcState = signal<DocCertProfCurent[]>([]);
    private readonly notificariState = signal<Notificari[]>([]);

    readonly transfer = this.transferState.asReadonly();
    readonly cpc = this.cpcState.asReadonly();
    readonly notificari = this.notificariState.asReadonly();

    setTransfer(transfer: Transfer[]) {
        this.transferState.set(transfer);
    }

    setCpc(cpc: DocCertProfCurent[]) {
        this.cpcState.set(cpc);
    }

    setNotificari(notificari: Notificari[]) {
        this.notificariState.set(notificari);
    }
}
